var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.25,
    fill: "#202124",
    stroke: "#494949",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9091 9.60001C11.0868 9.60001 9.6001 11.0867 9.6001 12.909V17.691C9.6001 19.5133 11.0868 21 12.9091 21H17.6911C19.5134 21 21.0001 19.5133 21.0001 17.691V12.909C21.0001 11.0867 19.5134 9.60001 17.6911 9.60001H12.9091ZM12.9091 10.4769H17.6911C19.039 10.4769 20.1232 11.5594 20.1232 12.909V17.691C20.1232 19.0389 19.0407 20.1231 17.6911 20.1231H12.9091C11.5612 20.1231 10.477 19.0406 10.477 17.691V12.909C10.477 11.5611 11.5595 10.4769 12.9091 10.4769ZM18.5886 11.3539C18.2255 11.3539 17.9309 11.6484 17.9309 12.0115C17.9309 12.3746 18.2255 12.6692 18.5886 12.6692C18.9517 12.6692 19.2463 12.3746 19.2463 12.0115C19.2463 11.6484 18.9517 11.3539 18.5886 11.3539ZM15.3001 12.2308C13.6096 12.2308 12.2309 13.6095 12.2309 15.3C12.2309 16.9905 13.6096 18.3692 15.3001 18.3692C16.9906 18.3692 18.3693 16.9905 18.3693 15.3C18.3693 13.6095 16.9906 12.2308 15.3001 12.2308ZM15.3001 13.1077C16.5161 13.1077 17.4924 14.084 17.4924 15.3C17.4924 16.5161 16.5161 17.4923 15.3001 17.4923C14.0841 17.4923 13.1078 16.5161 13.1078 15.3C13.1078 14.084 14.0841 13.1077 15.3001 13.1077Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.507fd117a26dfbecdff3c30127a27853.svg";
export { ForwardRef as ReactComponent };